// Variant quick add functionality
document.addEventListener('DOMContentLoaded', function() {
  // Initialize the variant quick add buttons
  const productCards = document.querySelectorAll('.m-product-card');
  
  productCards.forEach(card => {
    // Show variant selector on hover for desktop
    card.addEventListener('mouseenter', function() {
      const variantSelector = card.querySelector('.m-product-card__info .m-product-variant-selector');
      const productInfo = card.querySelector('.m-product-card__info');
      const productTitle = card.querySelector('.m-product-card__title');
      const productPrice = card.querySelector('.m-product-card__price');
      const productVendor = card.querySelector('.m-product-card__vendor');
      const productReviews = card.querySelector('.m-product-card__reviews');
      
      if (variantSelector) {
        variantSelector.style.opacity = '1';
        variantSelector.style.visibility = 'visible';
        variantSelector.style.transform = 'translateY(0)';
      }
      
      // Hide all product info elements to create space for the variant selector
      if (productTitle) productTitle.style.visibility = 'hidden';
      if (productPrice) productPrice.style.visibility = 'hidden';
      if (productVendor) productVendor.style.visibility = 'hidden';
      if (productReviews) productReviews.style.visibility = 'hidden';
    });
    
    // Hide variant selector on mouse leave
    card.addEventListener('mouseleave', function() {
      const variantSelector = card.querySelector('.m-product-card__info .m-product-variant-selector');
      const productTitle = card.querySelector('.m-product-card__title');
      const productPrice = card.querySelector('.m-product-card__price');
      const productVendor = card.querySelector('.m-product-card__vendor');
      const productReviews = card.querySelector('.m-product-card__reviews');
      
      if (variantSelector) {
        variantSelector.style.opacity = '0';
        variantSelector.style.visibility = 'hidden';
        variantSelector.style.transform = 'translateY(10px)';
      }
      
      // Show all product info elements again
      if (productTitle) productTitle.style.visibility = 'visible';
      if (productPrice) productPrice.style.visibility = 'visible';
      if (productVendor) productVendor.style.visibility = 'visible';
      if (productReviews) productReviews.style.visibility = 'visible';
    });
  });
}); 